// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-bar":"YvpBx","rc-tabs-tab-active":"_2H4C+","input-suffix":"Zip+v","nav-item":"SbHxL"};